import type { Router } from 'vue-router'
import { useAppStore } from '@/stores/portal-stores/general-stores/app'
import { useNavigationStore } from '@/stores/portal-stores/component-stores/navigation'
import type { DeepLinkSettings } from '../interfaces/IDeepLinkSettings'

export function setupAfterEach(router: Router) {
  router.afterEach(() => {
    const navigationStore = useNavigationStore()
    const appStore = useAppStore()

    const slug = appStore.deepLinkSettings.slug
    const parameters = appStore.deepLinkSettings.queryParameters

    navigationStore.setIsNavigating(false)

    if (slug !== undefined && parameters !== undefined) {
      appStore.setDeepLinkSettings({} as DeepLinkSettings)

      if (slug !== '') {
        router.push({
          path: slug,
          query: parameters
        })
      }
    }
  })
}
